import _asyncToGenerator from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createClass from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _regeneratorRuntime from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from 'tslib';
import { Logger } from '@notificare/web-logger';
var logger = new Logger('notificare/network');

function sleep(milliseconds) {
  return new Promise(function (resolve) {
    setTimeout(resolve, milliseconds);
  });
}

function base64Encode(data) {
  // eslint-disable-next-line no-restricted-globals
  return self.btoa(data);
}

var NotificareNetworkRequestError = /*#__PURE__*/function (_Error) {
  _inherits(NotificareNetworkRequestError, _Error);

  var _super = _createSuper(NotificareNetworkRequestError);

  function NotificareNetworkRequestError(response) {
    var _this;

    _classCallCheck(this, NotificareNetworkRequestError);

    _this = _super.call(this, "Failed to fetch a resource with response code '".concat(response.status, "'."));
    _this.response = response;
    Object.setPrototypeOf(_assertThisInitialized(_this), NotificareNetworkRequestError.prototype);
    return _this;
  }

  return _createClass(NotificareNetworkRequestError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function request(_x) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _a, url, _params$method, method, retries, attempt, response, delay;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = params.url, _params$method = params.method, method = _params$method === void 0 ? 'GET' : _params$method;
            logger.debug("".concat(method, " ").concat(url));
            retries = (_a = params.retries) !== null && _a !== void 0 ? _a : defaults.retries;
            attempt = 0;

          case 4:
            if (!(attempt <= retries)) {
              _context.next = 27;
              break;
            }

            response = void 0;
            _context.prev = 6;
            _context.next = 9;
            return fetch(url, {
              method: method,
              body: getRequestBody(params),
              headers: getRequestHeaders(params)
            });

          case 9:
            response = _context.sent;

            if (!response.ok) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", response);

          case 12:
            _context.next = 22;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](6);
            logger.warning("Request attempt #".concat(attempt + 1, " failed."), _context.t0);

            if (!(attempt < retries)) {
              _context.next = 22;
              break;
            }

            delay = calculateRetryDelayInMilliseconds(attempt, params);
            logger.debug("Retrying in ".concat(delay, " milliseconds...")); // eslint-disable-next-line no-await-in-loop

            _context.next = 22;
            return sleep(delay);

          case 22:
            if (!response) {
              _context.next = 24;
              break;
            }

            throw new NotificareNetworkRequestError(response);

          case 24:
            attempt += 1;
            _context.next = 4;
            break;

          case 27:
            logger.error('Request exceeded maximum retries.');
            throw new Error('Request exceeded maximum retries.');

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 14]]);
  }));
  return _request.apply(this, arguments);
}

function getRequestHeaders(params) {
  var headers = new Headers();
  headers.set('Accept', 'application/json');
  if (params.body) headers.set('Content-Type', 'application/json'); // if (params.formData) headers.set('Content-Type', 'multipart/form-data');

  var authorizationHeader = getAuthorizationHeader(params);
  if (authorizationHeader) headers.set('Authorization', authorizationHeader);
  return headers;
}

function getAuthorizationHeader(_ref) {
  var authorization = _ref.authorization;
  if (!authorization) return undefined;
  var basic = authorization.basic;

  if (basic) {
    var encoded = base64Encode("".concat(basic.username, ":").concat(basic.password));
    return "Basic ".concat(encoded);
  }

  var bearer = authorization.bearer;

  if (bearer) {
    return "Bearer ".concat(bearer);
  }

  return undefined;
}

function getRequestBody(params) {
  if (params.body) return JSON.stringify(params.body);
  if (params.formData) return params.formData;
  return undefined;
}

function calculateRetryDelayInMilliseconds(attempt, params) {
  var _a;

  var retryDelay = (_a = params.retryDelay) !== null && _a !== void 0 ? _a : defaults.retryDelay;

  if (typeof retryDelay === 'function') {
    return retryDelay(attempt);
  }

  return retryDelay;
}

var defaults = {
  retries: 3,
  retryDelay: function retryDelay(attempt) {
    return Math.pow(2, attempt) * 1000;
  } // 1000, 2000, 4000

};

function cloudRequest(_x2) {
  return _cloudRequest.apply(this, arguments);
}

function _cloudRequest() {
  _cloudRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var environment, path, searchParams, rest, url;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            environment = params.environment, path = params.path, searchParams = params.searchParams, rest = __rest(params, ["environment", "path", "searchParams"]);
            url = getCloudUrl(environment);
            url.pathname = path;
            searchParams === null || searchParams === void 0 ? void 0 : searchParams.forEach(function (value, key) {
              url.searchParams.set(key, value);
            });
            return _context2.abrupt("return", request(Object.assign(Object.assign({}, rest), {
              url: url,
              authorization: getCloudRequestAuthorization(environment)
            })));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _cloudRequest.apply(this, arguments);
}

function getCloudUrl(_ref2) {
  var useTestEnvironment = _ref2.useTestEnvironment;
  return useTestEnvironment ? new URL('https://cloud-test.notifica.re') : new URL('https://cloud.notifica.re');
}

function getCloudRequestAuthorization(_ref3) {
  var applicationKey = _ref3.applicationKey,
      applicationSecret = _ref3.applicationSecret;
  return {
    basic: {
      username: applicationKey,
      password: applicationSecret
    }
  };
}

function fetchCloudApplication(_x3) {
  return _fetchCloudApplication.apply(this, arguments);
}

function _fetchCloudApplication() {
  _fetchCloudApplication = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var language, rest, searchParams, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            language = params.language, rest = __rest(params, ["language"]);
            searchParams = new URLSearchParams();
            if (language) searchParams.set('language', language);
            _context3.next = 5;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: '/api/application/info',
              searchParams: searchParams
            }));

          case 5:
            response = _context3.sent;
            return _context3.abrupt("return", response.json());

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchCloudApplication.apply(this, arguments);
}

function fetchCloudAssetGroup(_x4) {
  return _fetchCloudAssetGroup.apply(this, arguments);
}

function _fetchCloudAssetGroup() {
  _fetchCloudAssetGroup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var deviceId, userId, group, rest, searchParams, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            deviceId = params.deviceId, userId = params.userId, group = params.group, rest = __rest(params, ["deviceId", "userId", "group"]);
            searchParams = new URLSearchParams({
              deviceID: deviceId
            });
            if (userId) searchParams.set('userID', userId);
            _context4.next = 5;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: "/api/asset/forgroup/".concat(encodeURIComponent(group)),
              searchParams: searchParams
            }));

          case 5:
            response = _context4.sent;
            return _context4.abrupt("return", response.json());

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchCloudAssetGroup.apply(this, arguments);
}

function registerCloudDevice(_x5) {
  return _registerCloudDevice.apply(this, arguments);
}

function _registerCloudDevice() {
  _registerCloudDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
    var payload, rest;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            payload = params.payload, rest = __rest(params, ["payload"]);
            _context5.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'POST',
              path: "/api/device",
              body: payload
            }));

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _registerCloudDevice.apply(this, arguments);
}

function updateCloudDevice(_x6) {
  return _updateCloudDevice.apply(this, arguments);
}

function _updateCloudDevice() {
  _updateCloudDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    var deviceId, payload, rest;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            deviceId = params.deviceId, payload = params.payload, rest = __rest(params, ["deviceId", "payload"]);
            _context6.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'PUT',
              path: "/api/device/".concat(encodeURIComponent(deviceId)),
              body: payload
            }));

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _updateCloudDevice.apply(this, arguments);
}

function deleteCloudDevice(_x7) {
  return _deleteCloudDevice.apply(this, arguments);
}

function _deleteCloudDevice() {
  _deleteCloudDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(params) {
    var deviceId, rest;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            deviceId = params.deviceId, rest = __rest(params, ["deviceId"]);
            _context7.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'DELETE',
              path: "/api/device/".concat(encodeURIComponent(deviceId))
            }));

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _deleteCloudDevice.apply(this, arguments);
}

function fetchCloudDeviceTags(_x8) {
  return _fetchCloudDeviceTags.apply(this, arguments);
}

function _fetchCloudDeviceTags() {
  _fetchCloudDeviceTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(params) {
    var deviceId, rest, response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            deviceId = params.deviceId, rest = __rest(params, ["deviceId"]);
            _context8.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: "/api/device/".concat(encodeURIComponent(deviceId), "/tags")
            }));

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response.json());

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fetchCloudDeviceTags.apply(this, arguments);
}

function addCloudDeviceTags(_x9) {
  return _addCloudDeviceTags.apply(this, arguments);
}

function _addCloudDeviceTags() {
  _addCloudDeviceTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params) {
    var deviceId, tags, rest;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            deviceId = params.deviceId, tags = params.tags, rest = __rest(params, ["deviceId", "tags"]);
            _context9.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'PUT',
              path: "/api/device/".concat(encodeURIComponent(deviceId), "/addtags"),
              body: {
                tags: tags
              }
            }));

          case 3:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _addCloudDeviceTags.apply(this, arguments);
}

function removeCloudDeviceTags(_x10) {
  return _removeCloudDeviceTags.apply(this, arguments);
}

function _removeCloudDeviceTags() {
  _removeCloudDeviceTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params) {
    var deviceId, tags, rest;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            deviceId = params.deviceId, tags = params.tags, rest = __rest(params, ["deviceId", "tags"]);
            _context10.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'PUT',
              path: "/api/device/".concat(encodeURIComponent(deviceId), "/removetags"),
              body: {
                tags: tags
              }
            }));

          case 3:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _removeCloudDeviceTags.apply(this, arguments);
}

function clearCloudDeviceTags(_x11) {
  return _clearCloudDeviceTags.apply(this, arguments);
}

function _clearCloudDeviceTags() {
  _clearCloudDeviceTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(params) {
    var deviceId, rest;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            deviceId = params.deviceId, rest = __rest(params, ["deviceId"]);
            _context11.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'PUT',
              path: "/api/device/".concat(encodeURIComponent(deviceId), "/cleartags")
            }));

          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _clearCloudDeviceTags.apply(this, arguments);
}

function fetchCloudDeviceDoNotDisturb(_x12) {
  return _fetchCloudDeviceDoNotDisturb.apply(this, arguments);
}

function _fetchCloudDeviceDoNotDisturb() {
  _fetchCloudDeviceDoNotDisturb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(params) {
    var deviceId, rest, response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            deviceId = params.deviceId, rest = __rest(params, ["deviceId"]);
            _context12.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: "/api/device/".concat(encodeURIComponent(deviceId), "/dnd")
            }));

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response.json());

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _fetchCloudDeviceDoNotDisturb.apply(this, arguments);
}

function updateCloudDeviceDoNotDisturb(_x13) {
  return _updateCloudDeviceDoNotDisturb.apply(this, arguments);
}

function _updateCloudDeviceDoNotDisturb() {
  _updateCloudDeviceDoNotDisturb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(params) {
    var deviceId, dnd, rest;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            deviceId = params.deviceId, dnd = params.dnd, rest = __rest(params, ["deviceId", "dnd"]);
            _context13.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'PUT',
              path: "/api/device/".concat(encodeURIComponent(deviceId), "/dnd"),
              body: dnd
            }));

          case 3:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _updateCloudDeviceDoNotDisturb.apply(this, arguments);
}

function clearCloudDeviceDoNotDisturb(_x14) {
  return _clearCloudDeviceDoNotDisturb.apply(this, arguments);
}

function _clearCloudDeviceDoNotDisturb() {
  _clearCloudDeviceDoNotDisturb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params) {
    var deviceId, rest;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            deviceId = params.deviceId, rest = __rest(params, ["deviceId"]);
            _context14.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'PUT',
              path: "/api/device/".concat(encodeURIComponent(deviceId), "/cleardnd")
            }));

          case 3:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _clearCloudDeviceDoNotDisturb.apply(this, arguments);
}

function fetchCloudDeviceUserData(_x15) {
  return _fetchCloudDeviceUserData.apply(this, arguments);
}

function _fetchCloudDeviceUserData() {
  _fetchCloudDeviceUserData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(params) {
    var deviceId, rest, response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            deviceId = params.deviceId, rest = __rest(params, ["deviceId"]);
            _context15.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: "/api/device/".concat(encodeURIComponent(deviceId), "/userdata")
            }));

          case 3:
            response = _context15.sent;
            return _context15.abrupt("return", response.json());

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _fetchCloudDeviceUserData.apply(this, arguments);
}

function updateCloudDeviceUserData(_x16) {
  return _updateCloudDeviceUserData.apply(this, arguments);
}

function _updateCloudDeviceUserData() {
  _updateCloudDeviceUserData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(params) {
    var deviceId, userData, rest;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            deviceId = params.deviceId, userData = params.userData, rest = __rest(params, ["deviceId", "userData"]);
            _context16.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'PUT',
              path: "/api/device/".concat(encodeURIComponent(deviceId), "/userdata"),
              body: userData
            }));

          case 3:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _updateCloudDeviceUserData.apply(this, arguments);
}

function registerCloudTestDevice(_x17) {
  return _registerCloudTestDevice.apply(this, arguments);
}

function _registerCloudTestDevice() {
  _registerCloudTestDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(params) {
    var deviceId, nonce, rest;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            deviceId = params.deviceId, nonce = params.nonce, rest = __rest(params, ["deviceId", "nonce"]);
            _context17.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'PUT',
              path: "/api/support/testdevice/".concat(encodeURIComponent(nonce)),
              body: {
                deviceID: deviceId
              }
            }));

          case 3:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _registerCloudTestDevice.apply(this, arguments);
}

function fetchCloudDeviceInbox(_x18) {
  return _fetchCloudDeviceInbox.apply(this, arguments);
}

function _fetchCloudDeviceInbox() {
  _fetchCloudDeviceInbox = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(params) {
    var _a, _b, deviceId, skip, limit, since, rest, searchParams, response;

    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            deviceId = params.deviceId, skip = params.skip, limit = params.limit, since = params.since, rest = __rest(params, ["deviceId", "skip", "limit", "since"]);
            searchParams = new URLSearchParams({
              skip: (_a = skip === null || skip === void 0 ? void 0 : skip.toString()) !== null && _a !== void 0 ? _a : '0',
              limit: (_b = limit === null || limit === void 0 ? void 0 : limit.toString()) !== null && _b !== void 0 ? _b : '100'
            });
            if (since) searchParams.set('since', since);
            _context18.next = 5;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: "/api/notification/inbox/fordevice/".concat(encodeURIComponent(deviceId)),
              searchParams: searchParams
            }));

          case 5:
            response = _context18.sent;
            return _context18.abrupt("return", response.json());

          case 7:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _fetchCloudDeviceInbox.apply(this, arguments);
}

function removeCloudDeviceInboxItem(_x19) {
  return _removeCloudDeviceInboxItem.apply(this, arguments);
}

function _removeCloudDeviceInboxItem() {
  _removeCloudDeviceInboxItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(params) {
    var id, rest;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            id = params.id, rest = __rest(params, ["id"]);
            _context19.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'DELETE',
              path: "/api/notification/inbox/".concat(encodeURIComponent(id))
            }));

          case 3:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _removeCloudDeviceInboxItem.apply(this, arguments);
}

function markCloudDeviceInboxAsRead(_x20) {
  return _markCloudDeviceInboxAsRead.apply(this, arguments);
}

function _markCloudDeviceInboxAsRead() {
  _markCloudDeviceInboxAsRead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(params) {
    var deviceId, rest;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            deviceId = params.deviceId, rest = __rest(params, ["deviceId"]);
            _context20.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'PUT',
              path: "/api/notification/inbox/fordevice/".concat(encodeURIComponent(deviceId))
            }));

          case 3:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _markCloudDeviceInboxAsRead.apply(this, arguments);
}

function clearCloudDeviceInbox(_x21) {
  return _clearCloudDeviceInbox.apply(this, arguments);
}

function _clearCloudDeviceInbox() {
  _clearCloudDeviceInbox = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(params) {
    var deviceId, rest;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            deviceId = params.deviceId, rest = __rest(params, ["deviceId"]);
            _context21.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'DELETE',
              path: "/api/notification/inbox/fordevice/".concat(encodeURIComponent(deviceId))
            }));

          case 3:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _clearCloudDeviceInbox.apply(this, arguments);
}

function fetchCloudDynamicLink(_x22) {
  return _fetchCloudDynamicLink.apply(this, arguments);
}

function _fetchCloudDynamicLink() {
  _fetchCloudDynamicLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(params) {
    var deviceId, url, rest, searchParams, response;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            deviceId = params.deviceId, url = params.url, rest = __rest(params, ["deviceId", "url"]);
            searchParams = new URLSearchParams({
              platform: 'Web'
            });
            if (deviceId) searchParams.set('deviceID', deviceId);
            _context22.next = 5;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: "/api/link/dynamic/".concat(encodeURIComponent(url)),
              searchParams: searchParams
            }));

          case 5:
            response = _context22.sent;
            return _context22.abrupt("return", response.json());

          case 7:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _fetchCloudDynamicLink.apply(this, arguments);
}

function createCloudEvent(_x23) {
  return _createCloudEvent.apply(this, arguments);
}

function _createCloudEvent() {
  _createCloudEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(params) {
    var payload, rest;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            payload = params.payload, rest = __rest(params, ["payload"]);
            _context23.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'POST',
              path: "/api/event",
              body: payload
            }));

          case 3:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _createCloudEvent.apply(this, arguments);
}

function fetchCloudInAppMessage(_x24) {
  return _fetchCloudInAppMessage.apply(this, arguments);
}

function _fetchCloudInAppMessage() {
  _fetchCloudInAppMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(params) {
    var context, deviceId, rest, response;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            context = params.context, deviceId = params.deviceId, rest = __rest(params, ["context", "deviceId"]);
            _context24.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: "/api/inappmessage/forcontext/".concat(encodeURIComponent(context)),
              searchParams: new URLSearchParams({
                deviceID: deviceId
              })
            }));

          case 3:
            response = _context24.sent;
            return _context24.abrupt("return", response.json());

          case 5:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _fetchCloudInAppMessage.apply(this, arguments);
}

function callCloudNotificationWebhook(_x25) {
  return _callCloudNotificationWebhook.apply(this, arguments);
}

function _callCloudNotificationWebhook() {
  _callCloudNotificationWebhook = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(params) {
    var payload, rest;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            payload = params.payload, rest = __rest(params, ["payload"]);
            _context25.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'POST',
              path: "/api/notification/webhook",
              body: payload
            }));

          case 3:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));
  return _callCloudNotificationWebhook.apply(this, arguments);
}

function uploadCloudNotificationReplyMedia(_x26) {
  return _uploadCloudNotificationReplyMedia.apply(this, arguments);
}

function _uploadCloudNotificationReplyMedia() {
  _uploadCloudNotificationReplyMedia = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(params) {
    var media, rest, formData, response;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            media = params.media, rest = __rest(params, ["media"]);
            formData = new FormData();
            formData.append('file', media);
            _context26.next = 5;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'POST',
              path: '/api/upload/reply',
              formData: formData
            }));

          case 5:
            response = _context26.sent;
            return _context26.abrupt("return", response.json());

          case 7:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));
  return _uploadCloudNotificationReplyMedia.apply(this, arguments);
}

function createCloudNotificationReply(_x27) {
  return _createCloudNotificationReply.apply(this, arguments);
}

function _createCloudNotificationReply() {
  _createCloudNotificationReply = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(params) {
    var payload, rest;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            payload = params.payload, rest = __rest(params, ["payload"]);
            _context27.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'POST',
              path: '/api/reply',
              body: payload
            }));

          case 3:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));
  return _createCloudNotificationReply.apply(this, arguments);
}

function fetchCloudNotification(_x28) {
  return _fetchCloudNotification.apply(this, arguments);
}

function _fetchCloudNotification() {
  _fetchCloudNotification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(params) {
    var id, rest, response;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            id = params.id, rest = __rest(params, ["id"]);
            _context28.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: "/api/notification/".concat(encodeURIComponent(id))
            }));

          case 3:
            response = _context28.sent;
            return _context28.abrupt("return", response.json());

          case 5:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));
  return _fetchCloudNotification.apply(this, arguments);
}

function fetchCloudPass(_x29) {
  return _fetchCloudPass.apply(this, arguments);
}

function _fetchCloudPass() {
  _fetchCloudPass = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(params) {
    var serial, rest, response;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            serial = params.serial, rest = __rest(params, ["serial"]);
            _context29.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: "/api/pass/forserial/".concat(encodeURIComponent(serial))
            }));

          case 3:
            response = _context29.sent;
            return _context29.abrupt("return", response.json());

          case 5:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));
  return _fetchCloudPass.apply(this, arguments);
}

function fetchCloudPassSaveLinks(_x30) {
  return _fetchCloudPassSaveLinks.apply(this, arguments);
}

function _fetchCloudPassSaveLinks() {
  _fetchCloudPassSaveLinks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(params) {
    var serial, rest, response;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            serial = params.serial, rest = __rest(params, ["serial"]);
            _context30.next = 3;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: "/api/pass/savelinks/".concat(encodeURIComponent(serial))
            }));

          case 3:
            response = _context30.sent;
            return _context30.abrupt("return", response.json());

          case 5:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30);
  }));
  return _fetchCloudPassSaveLinks.apply(this, arguments);
}

function fetchCloudUserInboxNotification(_x31) {
  return _fetchCloudUserInboxNotification.apply(this, arguments);
}

function _fetchCloudUserInboxNotification() {
  _fetchCloudUserInboxNotification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(params) {
    var id, deviceId, rest, encodedId, encodedDeviceId, response;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            id = params.id, deviceId = params.deviceId, rest = __rest(params, ["id", "deviceId"]);
            encodedId = encodeURIComponent(id);
            encodedDeviceId = encodeURIComponent(deviceId);
            _context31.next = 5;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              path: "/api/notification/userinbox/".concat(encodedId, "/fordevice/").concat(encodedDeviceId)
            }));

          case 5:
            response = _context31.sent;
            return _context31.abrupt("return", response.json());

          case 7:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31);
  }));
  return _fetchCloudUserInboxNotification.apply(this, arguments);
}

function removeCloudUserInboxItem(_x32) {
  return _removeCloudUserInboxItem.apply(this, arguments);
}

function _removeCloudUserInboxItem() {
  _removeCloudUserInboxItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(params) {
    var id, deviceId, rest, encodedId, encodedDeviceId;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            id = params.id, deviceId = params.deviceId, rest = __rest(params, ["id", "deviceId"]);
            encodedId = encodeURIComponent(id);
            encodedDeviceId = encodeURIComponent(deviceId);
            _context32.next = 5;
            return cloudRequest(Object.assign(Object.assign({}, rest), {
              method: 'DELETE',
              path: "/api/notification/userinbox/".concat(encodedId, "/fordevice/").concat(encodedDeviceId)
            }));

          case 5:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32);
  }));
  return _removeCloudUserInboxItem.apply(this, arguments);
}

export { NotificareNetworkRequestError, addCloudDeviceTags, callCloudNotificationWebhook, clearCloudDeviceDoNotDisturb, clearCloudDeviceInbox, clearCloudDeviceTags, createCloudEvent, createCloudNotificationReply, deleteCloudDevice, fetchCloudApplication, fetchCloudAssetGroup, fetchCloudDeviceDoNotDisturb, fetchCloudDeviceInbox, fetchCloudDeviceTags, fetchCloudDeviceUserData, fetchCloudDynamicLink, fetchCloudInAppMessage, fetchCloudNotification, fetchCloudPass, fetchCloudPassSaveLinks, fetchCloudUserInboxNotification, markCloudDeviceInboxAsRead, registerCloudDevice, registerCloudTestDevice, removeCloudDeviceInboxItem, removeCloudDeviceTags, removeCloudUserInboxItem, request, updateCloudDevice, updateCloudDeviceDoNotDisturb, updateCloudDeviceUserData, uploadCloudNotificationReplyMedia };